import styled from "styled-components";
import React from "react";

const NavigationStyled = styled.div`
    font-family: Arial,Helvetica Neue,Helvetica,sans-serif;
    ul{
    text-align: center;
      margin: 0;
      list-style: none;
      flex: 1;
      max-width: 600px;
      border-bottom: 1px solid #9e1c34;
      border-top: 1px solid #9e1c34;
            padding: 10px 0;
        li{
          display: inline-block;
          a{
            text-decoration: none;
          }
          span{
              display: inline-block;
              margin: 0 6px;
          }
        }
    }
`;

const pointCSS = {
    color: '#e9e9e9'
};

const Navigation = (props: any) => {

    const {menu} = props.data;

    let items = null;

    if (menu && menu.items) {
        items = menu.items.map((item: any, index: number) => (
            <li key={item.ID}><a href={item.guid}>{item.title}</a>
                {menu.items.length - 1 > index ? <span style={pointCSS}>•</span> : null}
            </li>
        ));
    }else{
        items = new Array(5).fill(null).map((item, index) => <li key={index}><a href='#a'>link {index+1}</a>{index < 4 ? (
            <span style={pointCSS}>•</span>) : null} </li>);
    }

    return (
        <NavigationStyled>
            <ul>
                {items}
            </ul>
        </NavigationStyled>
    );
};

export default Navigation;
